module.exports = __webpack_public_path__ + "img/en_2.143a74a5.jpg";